export const demoDialogTitleSx = {
  fontFamily: 'Nexa ExtraBold',
  fontSize: 24,
  lineHeight: 1.32,
  fontWeight: 800,
  letterSpacing: 0,
  '@media (min-width: 768px) and (max-width: 1199px)': {
    fontSize: 20,
  },
  '@media (max-width: 767px)': {
    fontSize: 16,
  },
}

export const demoDialogTextSx = {
  fontSize: 16,
  lineHeight: 1.5,
  letterSpacing: 0,
  '@media (min-width: 768px) and (max-width: 1199px)': {
    fontSize: 14,
  },
  '@media (max-width: 767px)': {
    fontSize: 12,
  },
}
